module.exports = __webpack_public_path__ + "static/media/ca-cover@2x.a7456b68.webp";